import { addActors, resetActors, resetActorsDelay } from '../../actions/game/actor.actions'
import { resetActiveTime } from '../../actions/game/activeTime.actions'
import { resetBattleLog } from '../../actions/game/battleLog.actions'
import { progressBattle, setBattleBanner } from '../../actions/game/battle.actions'
import { groupBy } from '../../../utils/helper'
import { goToBattleResult } from '../../actions/routing/route.actions'
import { addToProgress } from '../../actions/game/progression.actions'
import { selectTargetActor } from '../../actions/game/targetActor.actions'

const battleMiddleware = ({ getState, dispatch }) => next => (action) => {
    const { meta } = action
    const { battleStage } = meta || {}

    if (!battleStage) {
        next(action)
        return
    }

    switch (battleStage) {
        case 'init': {
            next(action)
            dispatch(progressBattle())
            break
        }

        case 'nextStep': {
            const {
                stage, squadUnits, currentStep, currentPhase,
            } = getState().battle
            const current = {
                step: currentStep,
                phase: currentPhase,
            }

            current.phase += 1
            if (stage.location[current.step][current.phase] === undefined) {
                current.step += 1
                current.phase = 0

                if (stage.location[current.step] === undefined) {
                    const stageID = stage.ID
                    dispatch(addToProgress({ stageID, outcome: 'won' }))
                    current.step = -1
                    current.phase = -1
                }
            }

            if (current.step === -1) { break }

            const nextPhase = stage.location[current.step][current.phase]
            current.status = nextPhase.battle ? 'active' : 'hold'
            next(Object.assign({}, action, { payload: current }))

            if (nextPhase.banner) {
                dispatch(setBattleBanner(nextPhase.banner))
                setTimeout(
                    () => {
                        dispatch(progressBattle())
                    },
                    2800
                )
                break
            }

            if (nextPhase.player) {
                dispatch(addActors(squadUnits))
                dispatch(progressBattle())
                break
            }

            if (nextPhase.story) {
                break
            }

            if (nextPhase.enemies) {
                dispatch(addActors(nextPhase.enemies))
                dispatch(progressBattle())
                break
            }

            if (nextPhase.battle) {
                // ToDo: create logic to start and pause the battle timer
                dispatch(resetActorsDelay())
            }
            break
        }

        case 'check': {
            next(action)
            const { battle, actors } = getState()
            const { good, bad } = groupBy(Object.values(actors), 'faction')
            const { stage: { ID: stageID } } = battle

            if (good && bad) {
                break
            }

            if (good) {
                dispatch(progressBattle())
                break
            }

            dispatch(addToProgress({ stageID, outcome: 'lost' }))
            break
        }

        case 'reset': {
            dispatch(selectTargetActor(''))
            dispatch(resetActors())
            dispatch(resetActiveTime())
            dispatch(resetBattleLog())
            next(action)
            break
        }

        case 'first':
        case 'repeat':
        case 'lost': {
            next(action)
            dispatch(goToBattleResult())
            break
        }

        default: {
            next(action)
        }
    }
}

export default battleMiddleware
